import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

import GoogleTranslateElement from './googleTranslateElement'

import { 
  ArrowIcon 
} from './SVGIcons';

import CatalogBtn from './CatalogBtn'
import Social from './Social'
import OffcanvasForm from './OffcanvasForm';

class Offcanvas extends Component {
  static defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true
  };

  state = {
    openMenus: {}, // объект для хранения состояний открытых меню
    showCallForm: false, // состояние для формы заказа звонка
    show_gt: false,
    searchQuery: '' // состояние для поискового запроса
  };

  componentDidMount() {
    if (this.props.show) {
      this.handleBodyScrollLock(true);
    }
    this.setState({
      show_gt: window.innerWidth < 1200
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.handleBodyScrollLock(this.props.show);
      // Сбрасываем открытые меню при закрытии
      if (!this.props.show) {
        this.setState({ openMenus: {}, showCallForm: false, searchQuery: '' });
      }
    }
  }

  componentWillUnmount() {
    if (this.props.show) {
      this.handleBodyScrollLock(false);
    }
  }

  handleBodyScrollLock = (lock) => {
    if (lock) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && this.props.backdrop) {
      this.props.hide();
    }
  };

  handleKeyDown = (e) => {
    if (this.props.keyboard && e.key === 'Escape' && this.props.show) {
      this.props.hide();
    }
  };

  toggleMenu = (index) => {
    this.setState(prevState => ({
      openMenus: {
        ...prevState.openMenus,
        [index]: !prevState.openMenus[index]
      }
    }));
  };

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Методы для поиска
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    if (this.state.searchQuery.trim()) {
      window.location.href = `/search?find=${encodeURIComponent(this.state.searchQuery.trim())}`;
    }
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const { show, hide, data, backdrop = true } = this.props;
    const { openMenus, showCallForm, show_gt, searchQuery } = this.state;

    const topmenu = data?.mobmenu || []
    const market = data?.market || []

    return (
      <>
        {/* Backdrop */}
        {backdrop && (
          <div
            className={`
              fixed inset-0 bg-black/50 backdrop-blur-[4.6px] z-40 
              transition-opacity duration-300 ease-in-out
              ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}
            `}
            onClick={this.handleBackdropClick}
            onKeyDown={this.handleKeyDown}
            role="presentation"
          />
        )}

        {/* Offcanvas - слева */}
        <div
          className={`
            fixed left-0 top-0 h-full w-full max-w-[288px] leading-none
            bg-white shadow-xl z-50 
            transition-transform duration-300 ease-in-out
            flex flex-col rounded-r-[25px] overflow-hidden
            ${show ? 'translate-x-0' : '-translate-x-full'}
          `}
          role="dialog"
          aria-modal="true"
          onKeyDown={this.handleKeyDown}
        >
          {/* Фиксированная шапка */}
          <div className="flex-shrink-0 px-[15px]">
            <div className="flex items-center justify-between h-[63px]">
              <div className='text-[22px] text-black font-semibold'>Меню</div>
              <button
                type="button"
                className="border-0 bg-[#F6F6F6] w-[106px] h-[40px] rounded-full flex items-center justify-center gap-[12px] text-[14px] text-black hover:bg-gray-200 transition-colors"
                onClick={hide}
                aria-label="Закрыть"
              >
                <span>Закрыть</span>
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 0.5L10.5 10.5" stroke="black" strokeLinecap="round"/>
                  <path d="M10.5 0.5L0.5 10.5" stroke="black" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            <CatalogBtn
              className='h-[40px] justify-center w-[258px] max-w-full flex items-center gap-[6px] rounded-full bg-[#032E41] cursor-pointer'
              menu={data?.katalog || []}
              href={data?.katalog_link}
            />
          </div>

          {/* Прокручиваемый контент */}
          <div className="flex-1 overflow-y-auto px-[15px] pt-[20px]">
            {topmenu.map((elm, index) => (
              <div key={index} className='mb-[24px]'>
                {/* Основной пункт меню */}
                <div className='flex justify-between items-center'>
                  <a className='flex items-center gap-[6px]' href={elm?.url}>
                    {elm?.image && (
                      <img src={elm?.image} alt={elm?.name} width={16} height={16} />
                    )}
                    <div className='text-[14px] text-black'>{elm?.name}</div>
                  </a>
                  
                  {/* Иконка справа */}
                  {elm?.submenu?.length > 0 ? (
                    <button 
                      onClick={() => this.toggleMenu(index)}
                      className="p-1 focus:outline-none hover:opacity-70 transition-opacity"
                    >
                      <svg 
                        width="9" 
                        height="6" 
                        viewBox="0 0 9 6" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        className={`transition-transform duration-200 ${openMenus[index] ? 'rotate-180' : ''}`}
                      >
                        <path d="M0.355469 0.353516L4.35547 4.35352L8.35547 0.353516" stroke="black" strokeOpacity="0.6"/>
                      </svg>
                    </button>
                  ) : (
                    <div className='p-1'>
                      <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.355469 8.35352L4.35547 4.35352L0.355468 0.353516" stroke="black" strokeOpacity="0.6"/>
                      </svg>
                    </div>
                  )}
                </div>

                {/* Подменю (аккордеон) */}
                {elm?.submenu?.length > 0 && (
                  <div 
                    className={`
                      overflow-hidden transition-all duration-200
                      ${openMenus[index] ? 'max-h-[500px] opacity-100 mt-[12px]' : 'max-h-0 opacity-0'}
                    `}
                  >
                    <div className='pl-[22px] space-y-[8px]'>
                      {elm.submenu.map((subItem, subIndex) => (
                        <a 
                          key={subIndex} 
                          href={subItem?.url}
                          className='block text-[14px] text-black/60 hover:text-black transition-colors'
                        >
                          {subItem?.name}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Простая форма поиска - после меню */}
            <div className='mb-[24px]'>
              <form onSubmit={this.handleSearchSubmit} className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={this.handleSearchChange}
                  placeholder="Поиск..."
                  className="w-full h-[36px] bg-gray-100 text-gray-800 placeholder-gray-400 rounded-lg pl-3 pr-8 text-[13px] outline-none focus:ring-1 focus:ring-[#009EE3] focus:bg-white transition-all"
                  autoComplete="off"
                />
                <button
                  type="submit"
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#009EE3] transition-colors"
                  aria-label="Найти"
                >
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5 14.5L11.5 10.5C12.5 9.3 13 7.8 13 6.2C13 2.9 10.3 0.2 7 0.2C3.7 0.2 1 2.9 1 6.2C1 9.5 3.7 12.2 7 12.2C8.6 12.2 10.1 11.7 11.3 10.8L15.3 14.8L15.5 14.5ZM7 11.2C4.2 11.2 2 9 2 6.2C2 3.4 4.2 1.2 7 1.2C9.8 1.2 12 3.4 12 6.2C12 9 9.8 11.2 7 11.2Z" fill="currentColor"/>
                  </svg>
                </button>
              </form>
            </div>

            {/* Блок с маркетплейсами из data.market */}
            <div className='mb-[24px]'>
              <div className='text-[12px] text-black/60 mb-[9px]'>Покупайте на маркетплейсах</div>
              <div className='flex items-center gap-[9px]'>
                {market.map((item, index) => (
                  <a
                    key={index}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className='hover:opacity-80 transition-opacity'
                  >
                    <img
                      src={item.image}
                      alt={item.name || 'Маркетплейс'}
                      width={42}
                      height={42}
                      className='w-[42px] h-[42px] object-contain'
                    />
                  </a>
                ))}
              </div>
            </div>

            {show_gt &&
              <div className='mt-[10px]'>
                <GoogleTranslateElement />
              </div>
            }
          </div>

          {/* Фиксированный футер */}
          <div className="flex-shrink-0 p-[15px]">
            <div className='text-[12px] text-black/60'>Адрес</div>
            <div className='mt-[3px] text-black text-[16px] font-semibold'>{data?.faddr}</div>
            <div className='flex items-center justify-between mt-[15px] gap-[4px]'>
              {/* Кнопка Заказать звонок с открытием формы */}
              <div 
                className='flex items-center justify-center gap-[9px] h-[40px] bg-[#009EE3] rounded-full text-[14px] px-[20px] cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                onClick={this.openCallForm}
              >
                <div className='text-white'>Заказать звонок</div>
                <ArrowIcon />
              </div>
              <Social social={data?.social || []} width={40} />
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Заказать звонок"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default Offcanvas;